import React from "react";

function Home (){
    return <h1>Welcome to M-PAiSA</h1>
}

export default Home;